import { createLucideIcon } from 'lucide-react';

const GitlabIcon = createLucideIcon('Gitlab', [
  [
    'path',
    {
      d: 'M22 13.29L18.67 3.29C18.6408 3.21823 18.5924 3.15594 18.53 3.11C18.4709 3.04995 18.3935 3.01126 18.31 3C18.2279 2.99853 18.1474 3.02303 18.08 3.07C18.0176 3.11594 17.9692 3.17823 17.94 3.25L15.68 9.92H8.32L6.1 3.26C6.08212 3.19263 6.04775 3.13077 6 3.08C5.92617 3.02216 5.83357 2.99367 5.74 3C5.65787 2.99853 5.57738 3.02303 5.51 3.07C5.44763 3.11594 5.39917 3.17823 5.37 3.25L2 13.29C1.95121 13.4391 1.95107 13.5999 1.9996 13.749C2.04813 13.8982 2.14282 14.0281 2.27 14.12L12 21L21.69 14.12C21.8281 14.0373 21.934 13.9101 21.9904 13.7593C22.0467 13.6085 22.0501 13.443 22 13.29Z',
      key: '1',
    },
  ],
]);

GitlabIcon.displayName = 'GitlabIcon';

export default GitlabIcon;
